var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import dayjs from "dayjs";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { RowModeIds } from "../../../builderPackage/components/editableDataGrid/editableDataGrid.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { SpareIssuesKeys } from "../../spareIssue/services/entity";
import PartInfoTooltip from "../../spareParts/purchaseRequistion/components/partInfoTooltip";
import { partDetailsByProductIdAPICall, priorityPickListApiCall, purchaseOrderPartListAPI } from "../services/apiCalls";
import { PurchaseOrderKeys } from "../services/entity";
var PartDetails = function (props) {
    var _getLocalStorageItem, _value$name, _crud$SpareIssuesKeys3, _crud$PurchaseOrderKe, _crud$PurchaseOrderKe2, _value$PurchaseOrderD;
    var onChange = props.onChange, value = props.value, _a = props.name, name = _a === void 0 ? "PurchaseOrderDetails" : _a;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var crud = useAppSelector(function (state) { return state.crud; });
    var rows = (_value$name = value === null || value === void 0 ? void 0 : value[name]) !== null && _value$name !== void 0 ? _value$name : [];
    var id = useParams().id;
    var totalsRow = useMemo(function () {
        var totals = {
            id: RowModeIds.Total,
            Product: "Total",
            ModifiedQuantity: 0
        };
        rows.forEach(function (r) {
            if (r.id === RowModeIds.Total)
                return;
            if (typeof r.ModifiedQuantity === "number")
                totals.ModifiedQuantity += r.ModifiedQuantity;
        });
        return totals;
    }, [rows]);
    useEffect(function () {
        priorityPickListApiCall({});
    }, []);
    useEffect(function () {
        var _crud$SpareIssuesKeys, _crud$SpareIssuesKeys2;
        if ((_crud$SpareIssuesKeys = crud[SpareIssuesKeys.PartDetails]) !== null && _crud$SpareIssuesKeys !== void 0 && _crud$SpareIssuesKeys.data && onChange)
            onChange(null, (_crud$SpareIssuesKeys2 = crud[SpareIssuesKeys.PartDetails]) === null || _crud$SpareIssuesKeys2 === void 0 ? void 0 : _crud$SpareIssuesKeys2.data);
    }, [(_crud$SpareIssuesKeys3 = crud[SpareIssuesKeys.PartDetails]) === null || _crud$SpareIssuesKeys3 === void 0 ? void 0 : _crud$SpareIssuesKeys3.data]);
    var getPartListByPagination = function (params) { return purchaseOrderPartListAPI(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread({
            skip: 0,
            take: 100,
            SupplierId: value === null || value === void 0 ? void 0 : value.SupplierId
        }, params.request)
    })); };
    var columns = [{
            type: "searchSelect",
            field: "Product",
            headerName: "Part name & code",
            editable: true,
            flex: 1,
            headerAlign: "left",
            minWidth: 250,
            getListData: getPartListByPagination,
            apiKey: "partList",
            placeholder: "Search Part by name",
            moreButtonText: "Search More...",
            getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.Name; },
            valueFormatter: function (value, row) { return (row === null || row === void 0 ? void 0 : row.ProductName) || (value === null || value === void 0 ? void 0 : value.Name); },
            valueGetter: function (value, row) { return ({
                Name: row === null || row === void 0 ? void 0 : row.ProductName,
                id: row === null || row === void 0 ? void 0 : row.ChildId,
                SkuCode: row === null || row === void 0 ? void 0 : row.ProductCode
            }); },
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                Product: value,
                ProductName: value === null || value === void 0 ? void 0 : value.Name,
                ProductId: value === null || value === void 0 ? void 0 : value.id
            }); },
            renderCell: function (params) {
                if (params.id === RowModeIds.Total)
                    return "Total";
            }
        }, {
            field: "UnitOfMeasurementName",
            headerName: "UOM",
            editable: false,
            flex: 1
        }, {
            type: "number",
            field: "Rate",
            headerName: "Purchase rate (₹)",
            editable: false,
            flex: 1
        }, {
            type: "number",
            field: "RequestedQuantity",
            headerName: "Requested Qty",
            editable: false,
            flex: 1,
            display: id !== undefined ? "flex" : "text"
        }, {
            type: "number",
            field: "ModifiedQuantity",
            headerName: "Modified Qty",
            editable: true,
            flex: 1
        }, {
            type: "date",
            field: "RequirementDate",
            headerName: "Fulfilment date",
            valueGetter: function (value) {
                return new Date(value);
            },
            valueFormatter: function (value, row) {
                if ((row === null || row === void 0 ? void 0 : row.id) === RowModeIds.Total) {
                    return undefined;
                }
                else {
                    return dayjs(value).format("DD/MM/YYYY");
                }
            },
            editable: true,
            flex: 1
        }, {
            type: "singleSelect",
            field: "PurchaseOrderPriorityId",
            headerName: "Priority",
            align: "center",
            editable: true,
            flex: 1,
            valueOptions: (_crud$PurchaseOrderKe = (_crud$PurchaseOrderKe2 = crud[PurchaseOrderKeys.Priority]) === null || _crud$PurchaseOrderKe2 === void 0 ? void 0 : _crud$PurchaseOrderKe2.data) !== null && _crud$PurchaseOrderKe !== void 0 ? _crud$PurchaseOrderKe : [],
            getOptionLabel: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            getOptionValue: function (value) { return value === null || value === void 0 ? void 0 : value.id; }
        }, {
            field: "Remarks",
            headerName: "Remarks",
            editable: true,
            flex: 1
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        onChange: onChange,
        columns: columns,
        dataGridHeader: "Part details",
        dataGridProps: {
            isCellEditable: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Total) {
                    return false;
                }
                else {
                    return true;
                }
            },
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            pinnedRows: {
                bottom: [totalsRow]
            },
            processRowUpdate: function (newRow, oldRow) { return __awaiter(void 0, void 0, void 0, function () {
                var _newRow$Product, _oldRow$Product, row, _newRow$Product2, _newRow$Product3, _newRow$Product4, _newRow$Product5, _response$data, _response$data2, _response$data3, _response$data4, _response$data5, _response$data6, _response$data7, _response$data8, _response$data9, _response$data10, _newRow$Product$Reque, _newRow$Product6, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            row = newRow;
                            if (!((newRow === null || newRow === void 0 || (_newRow$Product = newRow.Product) === null || _newRow$Product === void 0 ? void 0 : _newRow$Product.id) !== (oldRow === null || oldRow === void 0 || (_oldRow$Product = oldRow.Product) === null || _oldRow$Product === void 0 ? void 0 : _oldRow$Product.id))) return [3 /*break*/, 2];
                            return [4 /*yield*/, partDetailsByProductIdAPICall({
                                    request: {
                                        OrganizationId: UserOrganization,
                                        ProductId: newRow === null || newRow === void 0 || (_newRow$Product2 = newRow.Product) === null || _newRow$Product2 === void 0 ? void 0 : _newRow$Product2.id
                                    }
                                })];
                        case 1:
                            response = _a.sent();
                            row = _objectSpread(_objectSpread({}, newRow), {}, {
                                ChildId: newRow === null || newRow === void 0 || (_newRow$Product3 = newRow.Product) === null || _newRow$Product3 === void 0 ? void 0 : _newRow$Product3.id,
                                ProductCode: newRow === null || newRow === void 0 || (_newRow$Product4 = newRow.Product) === null || _newRow$Product4 === void 0 ? void 0 : _newRow$Product4.SkuCode,
                                ProductName: newRow === null || newRow === void 0 || (_newRow$Product5 = newRow.Product) === null || _newRow$Product5 === void 0 ? void 0 : _newRow$Product5.Name,
                                HsnId: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.HsnCodeId,
                                HsnCode: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.HsnCode,
                                UnitOfMeasurementId: response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.UnitOfMeasurementId,
                                UnitOfMeasurementName: response === null || response === void 0 || (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.UnitOfMeasurementName,
                                AvailableQuantity: response === null || response === void 0 || (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.AvailableQuantity,
                                TaxId: response === null || response === void 0 || (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.TaxId,
                                TaxName: response === null || response === void 0 || (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.TaxValue,
                                Rate: response === null || response === void 0 || (_response$data8 = response.data) === null || _response$data8 === void 0 || (_response$data8 = _response$data8.PurchaseBasePrice) === null || _response$data8 === void 0 ? void 0 : _response$data8.Rate,
                                ChargeId: response === null || response === void 0 || (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.ChargeId,
                                DiscountId: response === null || response === void 0 || (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.DiscountId,
                                RequestedQuantity: (_newRow$Product$Reque = newRow === null || newRow === void 0 || (_newRow$Product6 = newRow.Product) === null || _newRow$Product6 === void 0 ? void 0 : _newRow$Product6.RequestedQuantity) !== null && _newRow$Product$Reque !== void 0 ? _newRow$Product$Reque : 0
                            });
                            _a.label = 2;
                        case 2: return [2 /*return*/, row];
                    }
                });
            }); }
        },
        rows: (_value$PurchaseOrderD = value === null || value === void 0 ? void 0 : value.PurchaseOrderDetails) !== null && _value$PurchaseOrderD !== void 0 ? _value$PurchaseOrderD : [],
        validationModel: {
            ModifiedQuantity: function (value, row) { return value > (row === null || row === void 0 ? void 0 : row.AvailableQuantity) ? "Modified quantity should be less than ".concat(row === null || row === void 0 ? void 0 : row.AvailableQuantity) : undefined; }
        },
        cellInfoModel: {
            Product: function () {
                var _crud$PurchaseOrderKe3;
                return (_crud$PurchaseOrderKe3 = crud[PurchaseOrderKeys.PartDetailsByProductId]) !== null && _crud$PurchaseOrderKe3 !== void 0 && _crud$PurchaseOrderKe3.data ? /*#__PURE__*/ React.createElement(PartInfoTooltip, null) : null;
            }
        }
    }));
};
export default PartDetails;
